"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformAndValidateFormSGBodyDtoToCreateMissingPersonApiDomain = void 0;
const transformer_1 = require("../../../../auth/auth-forwarder/formsg/transformer");
const utils_1 = require("../../../../utils");
const form_sg_1 = require("../../../../utils/data/form-sg");
const api_domain_1 = require("../api-domain");
// =============================================================================
// Request
// =============================================================================
async function transformAndValidateFormSGBodyDtoToCreateMissingPersonApiDomain(dto, responseToQn) {
    const formSGDomain = (0, transformer_1.transformFormSGRequestBodyApiDtoToDomain)(dto);
    await (0, utils_1.assertValidations)(formSGDomain);
    const domain = (0, form_sg_1.mapFormSGResponseToDomain)(api_domain_1.CreateMissingPersonFormApiDomain, formSGDomain, responseToQn);
    await (0, utils_1.assertValidations)(domain);
    return domain;
}
exports.transformAndValidateFormSGBodyDtoToCreateMissingPersonApiDomain = transformAndValidateFormSGBodyDtoToCreateMissingPersonApiDomain;
//# sourceMappingURL=index.js.map